// Generated by CoffeeScript 2.7.0
var TagsSelect;

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default TagsSelect = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  template: `<popover-group-options wrapperClass='tags-edit-container'
                       optionsFilterPlaceholder='搜索标签'
                       :initialSelectedOptionIds='initialSelectedTagIds'
                       :optionsUrl='optionsUrl'
                       :formatDataFunc='formatTagGroups'
                       :needFooter='needFooter'
                       ref='popoverGroupOptionsRef'
                       @cancelClicked='cancelFunc'
                       @submitClicked='submitFunc'
                       @valueChanged='valueChangeFunc'
                       @optionsChanged='optionsChangedFunc'>
  <template slot='option-item-template' slot-scope='{ option }'>
    <div class='tip icon'>
      <i class='slp-origin' :style='{ color: option.color }'></i>
    </div>
    <div class='content'>
      <span>{{ option.name }}</span>
    </div>
    <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
  </template>

  <div slot='filter-blankslate' class='list-group'>
    <div class="list-group-name">没有相关的搜索结果</div>
  </div>

  <div slot='options-blankslate' class='list-group'>
    <div class="list-group-name">没有“标签”</div>
  </div>
</popover-group-options>`,
  props: {
    initialSelectedTagIds: {
      type: Array
    },
    optionsUrl: {
      type: String,
      default: '/tag_groups/receipt'
    },
    needFooter: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      tagGroups: []
    };
  },
  methods: {
    formatTagGroups: function(data) {
      return _.map(data, function(raw_tag_group) {
        raw_tag_group.options = _.clone(raw_tag_group.tags);
        delete raw_tag_group.tags;
        return raw_tag_group;
      });
    }
  }
});
